<div class="create-new-order-dialog-container">
    <div class="create-new-order-dialog-header-container">
        <div>  <p class="create-new-order-dialog-header-text create-new-order-section-headers">ADD NEW ORDER</p></div>
        <div><p class="create-new-order-dialog-sub-heading">You are about to create a new order, Are you sure?</p></div>
    </div>

    <div class="order-note-btn-dialog-container">

        <button class="cancel-note-dialog-btn" mat-flat-button type="button" (click)="cancelAddingNewOrder()">
            <div class="cancel-alt-btn-content">
                <span><p class="cancel-alt-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="add-new-order-note-btn" mat-flat-button type="button" (click)="createNewOrder()">
            <div class="add-new-order-btn-content">
                <img src="../../../../../assets/order-to-cash-icons/add_icon.svg" alt="Add Icon" class="add-new-order-icon">
                <span><p class="add-new-order-note-btn-text">ADD NEW</p></span>
            </div>
        </button>
    </div>

</div>

